<template>
	<!-- 运单审核 -->
	<div class="billOperationRecord public_Spacing waybill-examine-page">
		<div class="pulbic_oparetionBlock waybill-filter-card">
			<div class="waybill-section-head">
				<div>
					<div class="waybill-section-title">运单审核</div>
					<div class="waybill-section-subtitle">按申请人、车牌号、审核状态和时间范围筛选待处理运单</div>
				</div>
				<div class="waybill-total-chip">共 {{ pagingPageMo || 0 }} 条</div>
			</div>
			<div class="public_criteriaRange waybill-filter-fields">
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">申请人：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择" filterable>
						<el-option v-for="(item,index) in customerOptions" :key="index" :label="item.ORMTB421CA06" :value="item.ORMTB421CA08">
						</el-option>
					</el-select>
				</div> -->

				<div class="public_oparetionBlock_Menu waybill-filter-item">
					<label class="public_lbSty">申请人</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="el-input__inner pulic_carNumber" type="text" placeholder="请输入"
								v-model="applicantsh" />
						</div>
					</div>
				</div>

				<div class="public_oparetionBlock_Menu waybill-filter-item">
					<label class="public_lbSty">车牌号</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input maxlength="7" class="el-input__inner pulic_carNumber" type="text" placeholder="请输入"
								v-model="carNum" />
						</div>
					</div>
				</div>

				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">申请类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
						filterable>
						<el-option v-for="item in materielOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div> -->
				<div class="public_oparetionBlock_Menu waybill-filter-item">
					<label class="public_lbSty">审核状态</label>
					<el-select class="public_optionSty dropDown_Define" v-model="ORMTB421CA14" placeholder="请选择">
						<el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="public_operatArea waybill-toolbar">
				<div class="waybill-date-shortcuts">
					<span class="pulic_operatArea_now pulic_cursor waybill-date-pill" :class="dateNowDayActive?'public_dateActive':''"
						@click="getNowDay">当日</span>
					<span class="public_operatArea_yesterday pulic_cursor waybill-date-pill"
						:class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
					<span class="pulic_operatArea_now pulic_cursor waybill-date-pill" :class="dateNowMonthActive?'public_dateActive':''"
						@click="sameMonth">当月</span>
					<span class="public_operatArea_yesterday pulic_cursor waybill-date-pill"
						:class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
					<div class="public_operatArea_timePicker pulic_cursor waybill-date-picker-wrap">
						<el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
							range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
							start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor waybill-date-picker">
						</el-date-picker>
					</div>
				</div>
				<div class="public_operatBtn waybill-actions">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor waybill-query-btn" v-shiroHiden="solelist"
						id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
					<button v-if="multipleSelection.length>0" class="public_saleWater_daochu pulic_cursor waybill-batch-btn"
						@click="examBach" v-shiroHiden="solelist" id="查询"><i
							class="iconfont icon-daochu"></i>批量审核</button>
				</div>
			</div>
		</div>
		<div class="billOperationRecord-table pulbic_table_container waybill-table-card">
			<div class="waybill-table-toolbar">
				<div>
					<div class="waybill-section-title">审核列表</div>
					<div class="waybill-section-subtitle">勾选待审核运单后可进行批量审核</div>
				</div>
				<div class="waybill-selected-chip" v-if="multipleSelection.length>0">已选 {{ multipleSelection.length }} 条</div>
			</div>
			<el-table ref="multipleTable" tooltip-effect="dark" :data="tableData" style="width: 100%;" max-height="90%" stripe highlight-current-row
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(38,50,56,1)',background:'rgba(232,246,255,1)','font-weight':'bold'}"
				@selection-change="handleSelectionChange" class="public_tableColumn waybill-main-table">
				<!-- :cell-class-name="cellcb" -->
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="ORMTB421CA06" label="申请时间" min-width="170" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>
							<span>{{scope.row.ORMTB469CB01}}</span>
						</p>
				
					</template>
				</el-table-column>
				<el-table-column prop="ORMTB421CA06" label="装货地" min-width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>
							<span>{{scope.row.ORMTB469CA32}}</span>
						</p>
				
					</template>
				</el-table-column>
				<el-table-column prop="ORMTB421CA06" label="卸货地" min-width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>
							<span>{{scope.row.ORMTB469CA33}}</span>
						</p>

					</template>
				</el-table-column>
				
				<el-table-column prop="ORMTB421CA06" label="物料" min-width="120" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>
							<span>{{scope.row.ORMTB469CA07}}</span>
						</p>

					</template>
				</el-table-column>
				<el-table-column v-if="this.uobj.pertb005.pertb005cb00 =='CUS-1'" prop="ORMTB421CA06" label="申请人" min-width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>
							<span>{{scope.row.ORMTB469CA12}}</span>
						</p>
						<p style="color: #999;">
							<span>{{scope.row.ORMTB469CA39}}</span>
						</p>

					</template>
				</el-table-column>
				<el-table-column prop="ORMTB421CA06" label="车牌号" min-width="130">
					<template slot-scope="scope">
						<span class="waybill-plate">{{scope.row.CARPLATE || '--'}}</span>

					</template>
				</el-table-column>
				
				<el-table-column prop="ORMTB421CA06" label="申请状态" width="120">
					<template slot-scope="scope">
						<span class="waybill-status-tag waybill-status-pending" v-if="scope.row.ORMTB469CD01==0">待审核</span>
						<span class="waybill-status-tag waybill-status-pass" v-if="scope.row.ORMTB469CD01==1">通过</span>
						<span class="waybill-status-tag waybill-status-reject" v-if="scope.row.ORMTB469CD01==2">拒绝</span>
						<span class="waybill-status-tag waybill-status-cancel" v-if="scope.row.ORMTB469CD01==3">取消</span>

					</template>
				</el-table-column>
				<el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop"
					:label="item.label" :key="index" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="操作" width="170" fixed="right">
					<template slot-scope="scope">
						<div class="waybill-action-group">
							<el-button class="waybill-audit-btn" type="primary"
								v-if="scope.row.ORMTB469CD01==0" size="small" @click="isorderAudit(scope.row)"
								v-shiroHiden="solelist" id="审核">审核</el-button>
							<el-button class="waybill-detail-btn" type="primary"
								size="small" @click="DetailsClick(scope.row)">详情
							</el-button>
						</div>
					</template>
				</el-table-column>
				<template slot="empty">
					<div class="waybill-empty">
						<div class="waybill-empty-title">暂无运单审核数据</div>
						<div class="waybill-empty-desc">可调整筛选条件后重新查询</div>
					</div>
				</template>
			</el-table>
			<div class="pulbic_pagesize waybill-pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>
		<!-- 运单审核 -->
		<div class="public-dialog">
			<el-dialog title="运单详情" :visible.sync="oerderDetilsShow" width="45%" @close="detailsList=''"
				:closeOnClickModal='false' append-to-body custom-class="sales-waybill-examine-dialog">
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">装货地</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA32||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">卸货地</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA33||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">物料</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA07||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{shMasgObj.CARPLATE||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CB01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核时间</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CB02||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">取消时间</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CB04||''}}</div>
					</div>
					
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA12||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申核人</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CB03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核状态</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==0">待审核</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==1">通过</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==2">拒绝</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==3">取消</div>
					</div>
					<!-- <div class="DWD-li">
						<div class="DWD-li-title">申请备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB421CA04||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">
							<input type="text" v-model="isorderAuditText" maxlength="20">
						</div>
					</div> -->
				</div>
				<!-- <div class="DWD-li" style="height: 80px;color: #fff;" v-if="DetailsWaterurl!=''">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;color:#333 ;">凭证记录</div>
						<el-image v-for="(items,indexs) in DetailsWaterurl" :key="indexs"
							style="width: 80px; height: 80px" :src="items.url" :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li" v-else>
						<div class="DWD-li-title">凭证记录</div>
						<div class="DWD-li-text"></div>
					</div> -->
			</el-dialog>
		</div>
		<div class="public-dialog">
			<!-- 单个审核 -->
			<el-dialog title="运单审核" :visible.sync="isorderAuditShow" @close="detailsList=''" width="50%"
				:closeOnClickModal='false' append-to-body custom-class="sales-waybill-examine-dialog">
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">装货地</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA32||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">卸货地</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA33||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">物料</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA07||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{shMasgObj.CARPLATE||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CB01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{shMasgObj.ORMTB469CA12||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核状态</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==0">待审核</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==1">通过</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==2">拒绝</div>
						<div class="DWD-li-text" v-if="shMasgObj.ORMTB469CD01==3">取消</div>
					</div>
					<!-- <div class="DWD-li">
						<div class="DWD-li-title">申请备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB421CA04||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">
							<input type="text" v-model="isorderAuditText" maxlength="20">
						</div>
					</div> -->
				</div>
				<!-- <div class="DetailsWater-img">
					<div class="DetailsWater-img-text">上传提现凭证</div>
					<el-upload class="avatar-uploader" action="#" :auto-upload="false" :on-change="handleChangeAdd"
						list-type="picture-card" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
						<img v-if="imageUrl" :src="imageUrl" class="avatar">
						<i class="el-icon-plus"></i>
					</el-upload>

				</div> -->
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<!-- 批量审核 -->
			<el-dialog title="运单审核" :visible.sync="isorderCarShow" @close="dataCarList=[]" width="50%"
				:closeOnClickModal='false' append-to-body custom-class="sales-waybill-examine-dialog">
				<div class="DetailsWater-Dialog">

					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">
						
						<span id="" v-for="item in dataCarList">
							{{item.CARPLATE||''}}
						</span>
						
						</div>
					</div>

					<!-- <div class="DWD-li">
						<div class="DWD-li-title">申请备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB421CA04||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">
							<input type="text" v-model="isorderAuditText" maxlength="20">
						</div>
					</div> -->
				</div>
				<!-- <div class="DetailsWater-img">
					<div class="DetailsWater-img-text">上传提现凭证</div>
					<el-upload class="avatar-uploader" action="#" :auto-upload="false" :on-change="handleChangeAdd"
						list-type="picture-card" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
						<img v-if="imageUrl" :src="imageUrl" class="avatar">
						<i class="el-icon-plus"></i>
					</el-upload>
		
				</div> -->
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderCarServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderCarServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- 充值 -->
		<!-- <div class="public-dialog">
			<el-dialog title="充值详情" :visible.sync="oerderDetilsShow" width="35%" @close="detailsList=''"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值金额</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}</div>
					</div>
					<div class="DWD-li" style="height: 80px">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;">充值记录</div>
						<el-image
						    style="width: 80px; height: 80px"
						    :src="DetailsWaterurl" 
						    :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CC00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CE00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CD01||''}}</div>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="充值审核" :visible.sync="isorderAuditShow" @close="detailsList='',isorderAuditText=''" width="30%"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值金额</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}</div>
					</div>
					<div class="DWD-li" style="height: 80px">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;">充值记录</div>
						<el-image
						    style="width: 80px; height: 80px"
						    :src="DetailsWaterurl" 
						    :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核说明</div>
						<div class="DWD-li-text">
							<input  type="text" v-model="isorderAuditText" maxlength="20" >
						</div>
					</div>
					
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div> -->
		<!--  -->
	</div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
	export default {
  mixins: [customerSearchMixin],
		data() {
			return {
				isorderAuditText: '',
				ORMTB421ID: '',
				oerderDetilsShow: false,
				isorderAuditShow: false,
				isorderCarShow: false,
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				date: [], //日期
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				tableData: [],
				materialOptions: [],
				materialTypeValue: '',
				customerOptions: [],
				multipleSelection: [],
				applicantsh: '',
				shMasgObj: {},
				carNum: '',
				materielMo: '',
				materielOptions: [{
					value: '',
					label: '全部',
				}, {
					value: 'CZ',
					label: '充值',
				}, {
					value: 'TX',
					label: '提现',
				}],
				// 状态
				dataStatusOperation: [{
					value: '',
					label: '全部',
				}, {
					value: '0',
					label: '审核中',
				}, {
					value: '1',
					label: '通过',
				}, {
					value: '2',
					label: '拒绝',
				}],
				// 查询
				customerMo: '', //客户--查询		
				ORMTB421CA14: '', //数据状态
				billOperationAdd: false,
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				tableHeadList: [
					// {
					// 	prop: 'ORMTB469CB02',
					// 	label: '审核时间',
					// },
					{
						prop: 'ORMTB469CB03',
						label: '审核人',
					},
				],
				// 审核
				imageUrl: '',
				// 详情
				billOperationDetails: false,
				detailsList: '', //详情列表
				dataCarList: [],
				isRefresh: true,
				isRefreshSetInterval: '',
				// quanpDisabled: false,
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				solelist: [],
				DetailsWaterurl: '',
				DetailsWatersrcList: []
			}
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			} else {
				this.getNowDay();
			}
			var path = this.$route.path;
			if (path === '/SalesDispatchManagement') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		},
		mounted() {
			this.enterprise0ptions()
			this.pageList()
		},
		// 存储数据
		beforeDestroy() {
			this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
			this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
			var obj = {
				// startTime: [this.date[0], this.date[1]], //开始时间
				startTime: this.startTime,
				endTime: this.endTime, //开始时间
				customerMo: this.customerMo, //申请人
				materielMo: this.materielMo, //申请类型
				ORMTB421CA14: this.ORMTB421CA14, //审核状态
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			//初始化数据
			init() {
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.customerMo = this.historyInfo.customerMo
				this.materielMo = this.historyInfo.materielMo
				this.ORMTB421CA14 = this.historyInfo.ORMTB421CA14
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
			},
			// 上传图片
			handleChangeAdd(file, image) {
				this.imageUrl = image;
				// console.log(this.imageUrl)
			},
			// 导出
			exports() {
				var startTime = this.date[0]; //开始时间
				var endTime = this.date[1]; //结束时间
				var ORMTB421CA08 = this.customerMo; //二级客户ID
				var ORMTB421CA00 = this.materielMo; //物料ID
				var ORMTB421CA14 = this.ORMTB421CA14; //状态
				var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb421toExcle?startTime=" + startTime +
					"&endTime=" +
					endTime + "&ORMTB421CA08=" + ORMTB421CA08 + "&ORMTB421CA00=" + ORMTB421CA00 + "&ORMTB421CA14=" +
					ORMTB421CA14;
				window.location.href = url;
			},
			// 申请人--查询
			enterprise0ptions() {
				var List = [{
					ORMTB421CA08: '',
					ORMTB421CA06: '全部',
				}];
				var url = "/orm/ormtb421/selectOrmtb421CA06List";
				this.axios.post(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.customerOptions = [...List, ...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			handleSelectionChange(val) {
				console.log(val)
				// if (this.rowSelectFlag) return
				this.multipleSelection = val;
				// this.multipleSelection.push({
				// 	ORMTB468ID:val.ORMTB468ID,
				// 	CARPLATE:val.CARPLATE
				// })
				// console.log(this.multipleSelection)
			},
			// 查询
			queryClick() {
				this.pageList()
			},
			cellcb({ row }){
				// console.log(row)
			 	return row.ORMTB469CD01 ? 'myCell' : ''
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				console.log(this.uobj)
				var postData = {
					startTime: this.date[0], //开始时间
					endTime: this.date[1], //结束时间
					ORMTB469CA01: this.carNum, //车牌号
					ORMTB469CA12: this.applicantsh,
					// ORMTB410CA01: this.uobj.ormtb400.ORMTB400ID, //一级客户代码
					// ORMTB421CA00: this.materielMo, //申请类型
					ORMTB469CD01: this.ORMTB421CA14, //审核状态
					page: this.pageMo,
					limit: this.limitMo
				}
				this.tableData = [];
				var url = "/orm/ormtb460/ormtb469ListAdminSplit";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						console.log(res)
						var data = res.data.data.list;
						console.log(data)
						this.tableData = data;
						this.pagingPageMo = res.data.data.total;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			// 详情
			DetailsClick(row) {
				this.oerderDetilsShow = true;
				this.shMasgObj = row
				// this.querydetileTX(row)
			},
			isorderAudit(row) {
				console.log(row)
				this.isorderAuditShow = true
				// this.ORMTB421ID = row.ORMTB421ID
				this.shMasgObj = row
				this.dataCarList = []
				this.dataCarList.push({
					ORMTB468ID: row.ORMTB468ID,
					CARPLATE: row.CARPLATE
				})
				// this.querydetileTX(row)
			},
			isorderAuditServe(type) { //单个审核
				// if (type == 2) {
				// 	if (this.isorderAuditText.trim().length == 0) return this.$message.error('请填写审核备注')
				// }
				// console.log(this.imageUrl)
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb460/auditOrmtb460UnCarSplit";
				var postData = {
					ormtb468List: this.dataCarList, //车牌
					ORMTB469CD01: type
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						loading.close()
						this.$message({
							message: '审核成功',
							type: 'success'
						});
						this.isorderAuditShow = false
						this.dataCarList = []
						this.pageList()

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
						loading.close()
					}

				})
			},
			examBach() { //批量审核
				let dataCar = []
				this.multipleSelection.forEach(item => {
					this.dataCarList.push({
						ORMTB468ID: item.ORMTB468ID,
						CARPLATE: item.CARPLATE
					})
				})
				this.isorderCarShow = true

				// this.dataCarList = dataCar.toString()
				console.log(this.dataCarList)
				

			},
			isorderCarServe(type) {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb460/auditOrmtb460UnCarSplit";
				var postData = {
					ormtb468List: this.dataCarList, //车牌
					ORMTB469CD01: type
				}
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						loading.close()
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.isorderCarShow = false
						this.dataCarList = []
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
						loading.close()
					}
				
				})
			},
			// 提现详情
			querydetileTX(row) {
				var postData = {
					ORMTB421ID: row.ORMTB421ID, //id
				}
				this.detailsList = ''
				var url = "/orm/ormtb421/selectOrmtb421ById";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.detailsList = res.data.data;
						if (this.detailsList.ORMTB421CA19 != '') {
							this.detailsList.ORMTB421CA19.forEach(item => {
								this.DetailsWatersrcList.push(item.url)
							})
							this.DetailsWaterurl = this.detailsList.ORMTB421CA19
						} else {
							this.DetailsWatersrcList = []
							this.DetailsWaterurl = ''
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},
			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份 
					"d+": date.getDate(), //日 
					"h+": date.getHours(), //小时 
					"m+": date.getMinutes(), //分 
					"s+": date.getSeconds(), //秒 
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
					"S": date.getMilliseconds() //毫秒 
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},
			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
		}
	}
</script>

<style scoped>

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 120px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li-text {
		flex: 1;
	}

	.DWD-li-text input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		border: none;
		outline: none;
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.DetailsWater-img {
		margin-top: 30px;
	}

	.DetailsWater-img-text {
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}

	.car-number-add {
		/* text-transform: uppercase; */
	}

	.billOperationRecord-table {
		padding: 30px 20px 0;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}
	
	::v-deep .myCell .el-checkbox__input {
	  display: none
	}

.waybill-examine-page {
	min-height: 100%;
	padding: 12px;
	box-sizing: border-box;
	background: radial-gradient(circle at 8% 0%, rgba(25, 159, 255, 0.12), transparent 28%), linear-gradient(180deg, #eef7ff 0%, #f6f8fb 48%, #f3f6fa 100%);
	color: #263238;
}

.waybill-filter-card,
.waybill-table-card {
	border: 1px solid rgba(190, 218, 238, 0.72);
	border-radius: 16px;
	background: rgba(255, 255, 255, 0.96);
	box-shadow: 0 12px 32px rgba(30, 86, 130, 0.08);
}

.waybill-filter-card {
	margin-bottom: 10px !important;
	padding: 14px 16px;
}

.waybill-section-head,
.waybill-table-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	margin-bottom: 12px;
}

.waybill-section-title {
	position: relative;
	padding-left: 12px;
	color: #1f3a4a;
	font-size: 18px;
	font-weight: 700;
	line-height: 24px;
}

.waybill-section-title::before {
	content: '';
	position: absolute;
	left: 0;
	top: 5px;
	width: 4px;
	height: 14px;
	border-radius: 4px;
	background: linear-gradient(180deg, #199fff, #20da9c);
}

.waybill-section-subtitle {
	margin-top: 3px;
	padding-left: 12px;
	color: #7b8c98;
	font-size: 12px;
}

.waybill-total-chip,
.waybill-selected-chip {
	min-width: 92px;
	padding: 7px 14px;
	border-radius: 16px;
	background: #eef8ff;
	color: #0f7fc5;
	text-align: center;
	font-size: 13px;
	font-weight: 700;
}

.waybill-selected-chip {
	background: #ecfbf6;
	color: #159b75;
}

.waybill-filter-fields {
	display: grid;
	grid-template-columns: repeat(3, minmax(180px, 1fr));
	gap: 12px 16px;
	width: 100%;
}

.billOperationRecord .waybill-filter-item {
	display: block;
	height: auto;
	margin: 0;
}

.waybill-filter-item .public_lbSty {
	display: block;
	margin-bottom: 7px;
	color: #516674;
	font-size: 13px;
	font-weight: 700;
	line-height: 18px;
}

.waybill-filter-item .public_optionSty,
.waybill-filter-item .el-select,
.waybill-filter-item .el-input,
.waybill-filter-item .dropDown_Define {
	width: 100% !important;
}

.waybill-filter-item .pulic_carNumber {
	width: 100%;
	margin-top: 0;
	border-color: #d9e7f0;
	border-radius: 10px;
	background: #fbfdff;
	color: #263238;
}

.waybill-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	margin-top: 12px;
	padding-top: 12px;
	border-top: 1px solid #edf3f7;
}

.waybill-date-shortcuts,
.waybill-actions,
.waybill-action-group {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}

.waybill-date-pill {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 58px;
	height: 32px;
	padding: 0 14px;
	border: 1px solid #d6e7f2;
	border-radius: 18px;
	box-sizing: border-box;
	background: #f7fbfe;
	color: #49606e;
	font-size: 13px;
	transition: all 0.18s ease;
}

.waybill-date-pill:hover {
	border-color: #199fff;
	background: #ecf8ff;
	color: #0f7fc5;
}

.waybill-examine-page .public_dateActive {
	border-color: #199fff !important;
	background: linear-gradient(135deg, #199fff, #20b8d8) !important;
	color: #fff !important;
	box-shadow: 0 8px 18px rgba(25, 159, 255, 0.22);
}

.waybill-query-btn,
.waybill-batch-btn {
	min-width: 88px;
	height: 34px;
	padding: 0 16px;
	border: 0;
	border-radius: 10px;
	font-weight: 700;
}

.waybill-query-btn {
	background: linear-gradient(135deg, #199fff, #12aee5) !important;
	box-shadow: 0 8px 18px rgba(25, 159, 255, 0.22);
}

.waybill-batch-btn {
	background: linear-gradient(135deg, #20da9c, #14b98e) !important;
	box-shadow: 0 8px 18px rgba(32, 218, 156, 0.22);
}

.waybill-table-card {
	padding: 16px 16px 0 !important;
}

.waybill-plate {
	display: inline-block;
	min-width: 78px;
	padding: 4px 10px;
	border: 1px solid #cfe7f6;
	border-radius: 8px;
	background: #f3fbff;
	color: #0f7fc5;
	font-weight: 700;
}

.waybill-status-tag {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 72px;
	height: 26px;
	padding: 0 10px;
	border-radius: 13px;
	box-sizing: border-box;
	font-size: 12px;
	font-weight: 700;
}

.waybill-status-pending {
	background: #fff6e8;
	color: #d8840d;
}

.waybill-status-pass {
	background: #e9faf4;
	color: #10a777;
}

.waybill-status-reject,
.waybill-status-cancel {
	background: #fff0f0;
	color: #df4d4d;
}

.waybill-action-group {
	justify-content: center;
	gap: 8px;
}

.waybill-action-group .el-button {
	min-width: 58px;
	margin-left: 0;
	border-radius: 8px;
	font-weight: 700;
}

.waybill-audit-btn {
	color: #0f7fc5 !important;
	background: #eef8ff !important;
	border-color: #cbe7f8 !important;
}

.waybill-detail-btn {
	color: #159b75 !important;
	background: #ecfbf6 !important;
	border-color: #cde6dc !important;
}

.waybill-empty {
	padding: 42px 0;
	text-align: center;
}

.waybill-empty-title {
	color: #334955;
	font-size: 16px;
	font-weight: 700;
}

.waybill-empty-desc {
	margin-top: 8px;
	color: #8fa1ad;
	font-size: 13px;
}

.waybill-pagination {
	display: flex;
	justify-content: flex-end;
	padding: 16px 0 18px;
}

.DetailsWater-Dialog {
	max-height: 68vh;
	overflow-y: auto;
	padding-right: 6px;
}

.waybill-examine-page .DWD-li {
	align-items: center;
	min-height: 38px;
	height: auto;
	margin-bottom: 12px;
	border: none;
	line-height: 38px;
}

.waybill-examine-page .DWD-li-title {
	width: 120px;
	flex: 0 0 120px;
	border-right: none;
	background-color: transparent;
	color: #425766;
	text-align: left;
	font-size: 14px;
	font-weight: 700;
}

.waybill-examine-page .DWD-li-text {
	flex: 1;
	min-height: 34px;
	line-height: 32px;
	padding: 0 12px !important;
	border: 1px solid #dbe7ef;
	border-radius: 8px;
	background: #fbfdff;
	color: #667985;
	font-size: 13px;
}

.waybill-examine-page .DWD-li-text input {
	height: 32px;
	background: transparent;
	line-height: 32px;
}

::v-deep .waybill-filter-card .el-input__inner,
::v-deep .waybill-date-picker .el-input__inner {
	height: 36px;
	border-color: #d9e7f0;
	border-radius: 10px;
	background: #fbfdff;
	line-height: 36px;
}

::v-deep .waybill-date-picker.el-date-editor--datetimerange.el-input__inner {
	width: 380px;
}

::v-deep .waybill-main-table {
	border-radius: 12px;
	overflow: hidden;
}

::v-deep .waybill-main-table .el-table__header th {
	height: 46px;
}

::v-deep .waybill-main-table .el-table__row td {
	height: 52px;
	color: #455a64;
}

::v-deep .waybill-main-table .el-table__row:hover > td {
	background-color: #f0f9ff !important;
}

::v-deep .waybill-pagination .el-pager li.active {
	border-radius: 6px;
	background: #199fff;
	color: #fff;
}

::v-deep .public-dialog .el-dialog {
	border-radius: 16px;
	overflow: hidden;
}

::v-deep .public-dialog .el-dialog__header {
	margin: 0 24px;
	padding: 20px 0 16px !important;
	border-bottom: 1px solid #e5edf3;
	font-size: 20px;
	font-weight: 700;
}

::v-deep .public-dialog .el-dialog__body {
	padding: 22px 24px 26px;
}

@media (max-width: 1200px) {
	.waybill-filter-fields {
		grid-template-columns: repeat(2, minmax(180px, 1fr));
	}
}

@media (max-width: 760px) {
	.waybill-section-head,
	.waybill-table-toolbar,
	.waybill-toolbar {
		align-items: flex-start;
		flex-direction: column;
	}

	.waybill-filter-fields {
		grid-template-columns: 1fr;
	}

	::v-deep .waybill-date-picker.el-date-editor--datetimerange.el-input__inner {
		width: 100%;
	}
}

</style>
<style>
.sales-waybill-examine-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-waybill-examine-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-waybill-examine-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-waybill-examine-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-waybill-examine-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
